<template>
	<div class="d-flex flex-column gap-3">
		<p class="fs-3 fw-bold text-aareii-700 text-center">{{ $t('account.personal_data') }}</p>
		<div class="row">
			<label for="first_name" class="col-md-4 col-form-label text-md-end">{{ $t('account.first_name') }}</label>

			<div class="col-md-8">
				<input id="first_name" type="text" class="form-control" v-model="user.first_name">
			</div>
		</div>

		<div class="row">
			<label for="last_name" class="col-md-4 col-form-label text-md-end">{{ $t('account.last_name') }}</label>

			<div class="col-md-8">
				<input id="last_name" type="text" class="form-control" v-model="user.last_name">
			</div>
		</div>

		<div class="row">
			<label for="id_card" class="col-md-4 col-form-label text-md-end">{{ $t('account.id_card') }}</label>

			<div class="col-md-8">
				<input id="id_card" type="text" class="form-control" :placeholder="$t('general.only_numbers')" v-model="user.id_card">
			</div>
		</div>

		<div class="row">
			<label for="id_card_confirmation" class="col-md-4 col-form-label text-md-end">{{ $t('account.id_card_confirmation') }}</label>

			<div class="col-md-8">
				<input id="id_card_confirmation" type="text" class="form-control" :placeholder="$t('general.only_numbers')" v-model="user.id_card_confirmation">
			</div>
		</div>

		<div class="row">
			<label for="cuit" class="col-md-4 col-form-label text-md-end">{{ $t('account.cuit') }}</label>

			<div class="col-md-8">
				<input id="cuit" type="text" class="form-control" :placeholder="$t('account.cuit')" v-model="user.cuit">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('Gender') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.gender">
					<option value="m">{{ $t('Male') }}</option>
					<option value="f">{{ $t('Female') }}</option>
				</select>
			</div>
		</div>

		<div class="row">
			<label for="birthdate" class="col-md-4 col-form-label text-md-end">{{ $t('account.birthdate') }}</label>

			<div class="col-md-8">
				<input id="birthdate" type="date" class="form-control" v-model="user.birthdate">
			</div>
		</div>

		<div class="row">
			<label for="phone" class="col-md-4 col-form-label text-md-end">{{ $t('account.phone') }}</label>

			<div class="col-md-8">
				<input id="phone" type="tel" class="form-control" name="phone" v-model="user.phone">
				<div class="alert alert-info mb-0">
					<p class="fst-italic">{{ $t('account.phone_alert.1') }}</p>
					<p class="fw-bold">{{ $t('account.phone_alert.2') }}</p>
					<p class="mb-0">{{ $t('account.phone_alert.3') }}</p>
				</div>
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.nationality') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.country_id">
					<option v-for="country in countries" :value="country.id">{{ country.name }}</option>
				</select>
			</div>
		</div>

		<div class="row">
			<label for="location" class="col-md-4 col-form-label text-md-end">{{ $t('account.location.title') }}</label>

			<div class="col-md-8">
				<div class="d-flex align-items-center gap-3" v-if="user.location !== null">
					<img :src="user.location.country.image_url" class="flag" :alt="user.location.country.name">
					<span>{{ user.location.name+(user.location.region !== null ? ', '+user.location.region.name : '') }}, {{ user.location.country.name }} <span class="text-muted">({{ coordinates(user.location.lat, user.location.long) }})</span></span>
					<button type="button" class="btn btn-info" data-bs-toggle="modal" data-bs-target="#location-modal">
						<i>{{ $t('account.location.change') }}</i>
					</button>
				</div>
				<button v-else type="button" class="btn btn-info" data-bs-toggle="modal" data-bs-target="#location-modal">
					<i>{{ $t('account.location.select') }}</i>
				</button>
				<div class="modal fade" id="location-modal" tabindex="-1" aria-labelledby="location-modal-label" aria-hidden="true">
					<div class="modal-dialog modal-xl">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title" id="location-modal-label">{{ $t('account.location.title') }}</h5>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
							</div>
							<div class="modal-body d-flex flex-column gap-3">
								<div class="input-group">
									<input id="location" type="text" class="form-control" v-model="location_search" @keypress.enter="search_location">
									<button class="btn btn-info" @click="search_location">
										<i class="fa-solid fa-search"></i>
									</button>
								</div>
								<div v-if="locations.length > 0" class="list-group">
									<div v-for="location in locations" :key="'location_'+location.id" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" @click="select_location(location)">
										<span>
											<img :src="location.country.image_url" class="flag me-2" :alt="location.country.name">
											{{ location.name+(location.region !== null ? ', '+location.region.name : '') }}, {{ location.country.name }} <span class="text-muted">({{ coordinates(location.lat, location.long) }})</span>
										</span>
										<i class="fa-solid fa-check text-success" v-if="user.location_id === location.id"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<label for="address" class="col-md-4 col-form-label text-md-end">{{ $t('account.address') }}</label>

			<div class="col-md-8">
				<input id="address" type="text" class="form-control" v-model="user.address">
			</div>
		</div>
		<p class="fs-3 fw-bold text-aareii-700 text-center">{{ $t('account.academic_data') }}</p>
		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.major') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.major_id">
					<option v-for="major in majors" :value="major.id">{{ major.name }}</option>
					<option :value="null">{{ $t('general.other') }}</option>
				</select>
			</div>
		</div>

		<div class="row" v-if="user.major_id === null">
			<label for="other_major" class="col-md-4 col-form-label text-md-end">{{ $t('account.other_major') }}</label>

			<div class="col-md-8">
				<input id="other_major" type="text" class="form-control" v-model="user.other_major">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.college') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.college_id">
					<option v-for="college in colleges" :value="college.id">{{ college.name }}</option>
					<option :value="null">{{ $t('general.other') }}</option>
				</select>
			</div>
		</div>

		<div class="row" v-if="user.college_id === null">
			<label for="other_college" class="col-md-4 col-form-label text-md-end">{{ $t('account.other_college') }}</label>

			<div class="col-md-8">
				<input id="other_college" type="text" class="form-control" v-model="user.other_college">
			</div>
		</div>

		<div class="row">
			<label for="credits" class="col-md-4 col-form-label text-md-end">{{ $t('account.credits') }}</label>

			<div class="col-md-8">
				<input id="credits" type="number" class="form-control" name="credits" v-model="user.credits">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.experience.work') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.work_experience">
					<option :value="1">{{ $t('general.yes') }}</option>
					<option :value="0">{{ $t('general.no') }}</option>
				</select>
			</div>
		</div>

		<div class="row" v-if="user.work_experience === 1">
			<label for="work_place" class="col-md-4 col-form-label text-md-end">{{ $t('account.where') }}</label>

			<div class="col-md-8">
				<input id="work_place" type="text" class="form-control" v-model="user.work_place">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.experience.ngo') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.ngo_experience">
					<option :value="1">{{ $t('general.yes') }}</option>
					<option :value="0">{{ $t('general.no') }}</option>
				</select>
			</div>
		</div>

		<div class="row" v-if="user.ngo_experience === 1">
			<label for="ngo_place" class="col-md-4 col-form-label text-md-end">{{ $t('account.where') }}</label>

			<div class="col-md-8">
				<input id="ngo_place" type="text" class="form-control" v-model="user.ngo_place">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.work_region') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.work_region">
					<option :value="1">{{ $t('general.yes') }}</option>
					<option :value="0">{{ $t('general.no') }}</option>
				</select>
			</div>
		</div>

		<div class="row" v-if="user.work_region === 1">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.where') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.work_region_place">
					<option v-for="region in regions" :key="'work_region_place_'+region.id" :value="region.id">{{ region.name }}</option>
				</select>
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.academic_status.title') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.academic_status">
					<option :value="1">{{ $t('account.academic_status.alumnus') }}</option>
					<option :value="0">{{ $t('account.academic_status.student') }}</option>
				</select>
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.languages.title') }}</label>

			<div class="col-md-8">
				<div class="input-group">
					<select class="form-select" v-model="selected_language">
						<option v-for="lang in languages" :key="'langs_'+lang.id" :value="lang">{{ lang.name }}</option>
					</select>
					<button class="btn btn-success" @click="add_language">
						<i class="fa-solid fa-plus"></i>
					</button>
				</div>
				<div v-for="(lang, lang_i) in user.languages" :key="'user_langs_'+lang.id" class="input-group mt-3">
					<span class="input-group-text fw-bold">{{ lang.name }}</span>
					<select class="form-select" v-model="lang.pivot.level">
						<option :value="1">{{ $t('account.languages.levels.1') }}</option>
						<option :value="2">{{ $t('account.languages.levels.2') }}</option>
						<option :value="3">{{ $t('account.languages.levels.3') }}</option>
						<option :value="4">{{ $t('account.languages.levels.4') }}</option>
					</select>
					<button class="btn btn-danger" @click="remove_language(lang_i)">
						<i class="fa-solid fa-trash-can"></i>
					</button>
				</div>
			</div>
		</div>
		<p class="fs-3 fw-bold text-aareii-700 text-center">{{ $t('account.medical_data') }}</p>
		<div class="row">
			<label for="emergency_name" class="col-md-4 col-form-label text-md-end">{{ $t('account.emergency.name') }}</label>

			<div class="col-md-8">
				<input id="emergency_name" type="text" class="form-control" v-model="user.emergency_name">
			</div>
		</div>

		<div class="row">
			<label for="emergency_phone" class="col-md-4 col-form-label text-md-end">{{ $t('account.emergency.phone') }}</label>

			<div class="col-md-8">
				<input id="emergency_phone" type="tel" class="form-control" v-model="user.emergency_phone">
				<div class="alert alert-info mb-0">
					<p class="fst-italic">{{ $t('account.phone_alert.1') }}</p>
					<p class="fw-bold">{{ $t('account.phone_alert.2') }}</p>
					<p class="mb-0">{{ $t('account.phone_alert.3') }}</p>
				</div>
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.allergies') }}</label>

			<div class="col-md-8">
				<textarea class="form-control" v-model="user.allergies"></textarea>
				<div class="alert alert-info">
					{{ $t('account.allergies_alert') }}
				</div>
			</div>
		</div>

		<div class="row">
			<label for="healthcare" class="col-md-4 col-form-label text-md-end">{{ $t('account.healthcare') }}</label>

			<div class="col-md-8">
				<input id="healthcare" type="text" class="form-control" v-model="user.healthcare">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.diet.title') }}</label>

			<div class="col-md-8">
				<div class="alert alert-light" v-html="$t('account.dietetic_needs_register', {'email': email})"></div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="celiac_disease" @click="user.celiac_disease = (user.celiac_disease + 1) % 2" :checked="user.celiac_disease">
					<label class="form-check-label" for="celiac_disease">
						{{ $t('account.diet.celiac') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="lactose_intolerant" @click="user.lactose_intolerant = (user.lactose_intolerant + 1) % 2" :checked="user.lactose_intolerant">
					<label class="form-check-label" for="lactose_intolerant">
						{{ $t('account.diet.lactose') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="vegetarian" @click="user.vegetarian = (user.vegetarian + 1) % 2" :checked="user.vegetarian">
					<label class="form-check-label" for="vegetarian">
						{{ $t('account.diet.vegetarian') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="vegan" @click="user.vegan = (user.vegan + 1) % 2" :checked="user.vegan">
					<label class="form-check-label" for="vegan">
						{{ $t('account.diet.vegan') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="ketogenic_diet" @click="user.ketogenic_diet = (user.ketogenic_diet + 1) % 2" :checked="user.ketogenic_diet">
					<label class="form-check-label" for="ketogenic_diet">
						{{ $t('account.diet.keto') }}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="other_diet" @click="user.other_diet = (user.other_diet + 1) % 2" :checked="user.other_diet">
					<label class="form-check-label" for="other_diet">
						{{ $t('general.other') }}
					</label>
				</div>
			</div>
		</div>
		<p class="fs-3 fw-bold text-aareii-700 text-center">{{ $t('account.misc_data') }}</p>
		<div class="row">
			<label for="shoe_size" class="col-md-4 col-form-label text-md-end">{{ $t('account.shoe_size') }}</label>

			<div class="col-md-8">
				<input id="shoe_size" type="text" class="form-control" v-model="user.shoe_size">
			</div>
		</div>

		<div class="row">
			<label class="col-md-4 col-form-label text-md-end">{{ $t('account.shirt_size') }}</label>

			<div class="col-md-8">
				<select class="form-select" v-model="user.shirt_size">
					<option value="XS">{{ $t('XS') }}</option>
					<option value="S">{{ $t('S') }}</option>
					<option value="M">{{ $t('M') }}</option>
					<option value="L">{{ $t('L') }}</option>
					<option value="XL">{{ $t('XL') }}</option>
					<option value="2XL">{{ $t('2XL') }}</option>
					<option value="3XL">{{ $t('3XL') }}</option>
				</select>
			</div>
		</div>
		<p class="fs-3 fw-bold text-aareii-700 text-center">{{ $t('account.account_data') }}</p>
		<div class="row">
			<label for="email" class="col-md-4 col-form-label text-md-end">{{ $t('account.email') }}</label>

			<div class="col-md-8">
				<input id="email" type="email" class="form-control" v-model="user.email" required autocomplete="email">
			</div>
		</div>

		<div class="row">
			<label for="password" class="col-md-4 col-form-label text-md-end">{{ $t('account.password') }}</label>

			<div class="col-md-8">
				<input id="password" type="password" class="form-control" v-model="user.password" autocomplete="new-password">
			</div>
		</div>

		<div class="row">
			<label for="password_confirmation" class="col-md-4 col-form-label text-md-end">{{ $t('account.password_confirmation') }}</label>

			<div class="col-md-8">
				<input id="password_confirmation" type="password" class="form-control" v-model="user.password_confirmation" autocomplete="new-password">
			</div>
		</div>
		<div class="d-flex justify-content-center">
			<button type="button" class="btn btn-success" @click="register">
				<i class="fa-solid fa-check me-2"></i>
				{{ $t('general.confirm') }}
			</button>
		</div>
	</div>
</template>

<script>
import { reactive, ref } from 'vue'
import axios from 'axios'

export default {
	name: "register",
	props: {
		register_url: String,
		location_url: String,
		email: String,
		majors: Array,
		regions: Array,
		colleges: Array,
		languages: Array,
		countries: Array
	},
	setup(props){
		const majors = reactive(props.majors)
		const regions = reactive(props.regions)
		const colleges = reactive(props.colleges)
		const languages = reactive(props.languages)
		const countries = reactive(props.countries)
		const locations = ref([])
		const user = ref({
			first_name: null,
			last_name: null,
			email: null,
			password: null,
			password_confirmation: null,
			id_card: null,
			id_card_confirmation: null,
			cuit: null,
			gender: null,
			birthdate: null,
			phone: null,
			major_id: null,
			other_major: null,
			college_id: null,
			other_college: null,
			credits: null,
			credits_required: null,
			work_experience: 0,
			work_place: null,
			ngo_experience: 0,
			ngo_place: null,
			work_region: 0,
			work_region_place: null,
			academic_status: 0,
			emergency_name: null,
			emergency_phone: null,
			allergies: null,
			healthcare: null,
			shoe_size: null,
			shirt_size: null,
			celiac_disease: 0,
			lactose_intolerant: 0,
			vegetarian: 0,
			vegan: 0,
			ketogenic_diet: 0,
			other_diet: 0,
			country_id: null,
			state_id: null,
			location_id: null,
			location: null,
			address: null,
			languages: []
		})
		const location_search = ref('')
		const selected_language = ref(null)
		return {
			user,
			majors,
			regions,
			colleges,
			languages,
			locations,
			countries,
			location_search,
			selected_language
		}
	},
	methods: {
		/**
		 * Reduce an array to only have the given key's value
		 * @param {Array<any>} array array to reduce
		 * @param {string} key key to conserve
		 * @returns {Array<any>}
		 */
		pluck(array, key){
			return array.map(o => o[key])
		},
		add_language(){
			if(this.selected_language !== null && this.pluck(this.user.languages, 'id').indexOf(this.selected_language.id) === -1){
				this.user.languages.push({
					id: this.selected_language.id,
					name: this.selected_language.name,
					pivot: {
						level: 1
					}
				})
			}
		},
		remove_language(lang_i){
			this.user.languages.splice(lang_i, 1)
		},
		/**
		 * Calculate coordinate string
		 * @param {number} lat latitude
		 * @param {number} long longitude
		 * @return {string} the coordinates in text format like "LATº {N|S}, LONGº {E|W}"
		 */
		coordinates(lat, long){
			let res = Math.abs(lat).toString()
			if(lat > 0){
				res += 'º '+this.$t('general.coord.n')
			} else if(lat < 0){
				res += 'º '+this.$t('general.coord.s')
			}
			res += ', '+Math.abs(long).toString()
			if(long > 0){
				res += 'º '+this.$t('general.coord.e')
			} else if(long < 0){
				res += 'º '+this.$t('general.coord.w')
			}
			return res
		},
		select_location(location){
			this.user.location_id = location.id
			this.user.location = location
		},
		search_location() {
			window.showInfo(this.$t('general.searching'))
			axios.post(this.$props.location_url, {
				search: this.location_search
			}).then(({data}) => {
				if(data.res){
					this.locations = data.items
					window.showSuccess(this.$t('general.shown'))
				}
			}).catch(window.showValidationErrors)
		},
		register() {
			window.showInfo(this.$t('account.messages.registering'))
			axios.post(this.$props.register_url, this.user).then(({data}) => {
				window.redirect(data.redirect_url)
			}).catch(window.showValidationErrors)
		}
	}
}
</script>
